import React, { createContext } from 'react';

export const MainContext = createContext();
